import React, {useCallback, useState, useEffect} from 'react'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemButton from '@mui/material/ListItemButton';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import { NavLink } from 'react-router-dom'
import Switch from '@mui/material/Switch';
import AutoreplyDetailsModal from '../modals/AutoreplyDetailsModal'
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailReadRounded';
import CallMissedIcon from '@mui/icons-material/CallMissedRounded';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutlineRounded';
import BlockIcon from '@mui/icons-material/BlockRounded';
import AlarmOffIcon from '@mui/icons-material/AlarmOffRounded';
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearchRounded';
import {useDispatch, useSelector} from 'react-redux'
import endpoints, {apiRequest} from '../../../endpoints'
import { colors } from '../../../settings'
import { formatDateTime } from '../../../helpers'

export default function Autoreply(props) {
    const [list, setList] = useState()
    const [detailsItem, setDetailsItem] = useState()
    
    const token = useSelector((state) => state.auth.token)
    
    const getList = async () => {
        try {
            const res = await apiRequest('get', endpoints.autoreply, {
                token: token,
                perpage: 5,
            }, false)
            
            setList(res.data.items)
        } catch (e) {
            setList([])
        }
    }
    
    useEffect(() => {
        getList()
    }, [])
    
    return (
        <Paper sx={{minHeight:270}}>
            <Stack>
                <Stack direction="row" sx={{flexGrow:1, pl:3, pr:2, pt:2}} alignItems="center">
                    <Typography variant="subtitle1" sx={{flexGrow:1}}>
                        Autoreply
                    </Typography>
                    <Button component={NavLink} to="autoreply-email" size="small">
                        Show All
                    </Button>
                </Stack>
                <List sx={{overflowX: 'hidden'}}>
                    {list?.map((row) => (
                        <ListItem
                            key={row.id}
                            disablePadding
                        >
                            <ListItemButton 
                                component={NavLink}
                                onClick={() => {setDetailsItem(row)}}
                                sx={{pt:0.25, pb:0.25}}
                            >
                                <ListItemIcon>
                                    {row.details?.spam == 'yes' ? <BlockIcon /> : null}
                                    {row.details?.spam?.indexOf('Error:') == 0 ? <ErrorOutlineIcon /> : null }
                                    {row.details ? null : <CallMissedIcon /> }
                                    {row.details?.country ? <CallMissedIcon /> : null }
                                    {row.sent_at ? <MarkEmailReadIcon /> : null }
                                    {row.details?.time ? <AlarmOffIcon /> : null }
                                </ListItemIcon>
                                <ListItemText 
                                    primary={row.input_content || '(no content)'} 
                                    primaryTypographyProps={{
                                        style: {
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis'
                                        }
                                    }}
                                    secondary={formatDateTime(row.created_at)}
                                />
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
                {list?.length ? null :
                <div style={{textAlign:'center', paddingTop: '65px', fontSize: '15px'}}>No data to display</div>
                }
            </Stack>
            <AutoreplyDetailsModal data={detailsItem} onClose={() => {setDetailsItem(null)}} />
        </Paper>
    )
}